import React from 'react';
import {
  splitList, splitListRow, splitListTitle, splitListSubtitle, splitListAmount, splitListFooter,
} from './constants';

/**
 * The per-engagement / per-company input list of a split field (Estimated
 * fees, Expected FS signing date): one row per line — the company, the
 * service in grey under it, the input on the right — and an optional footer
 * row (the fees' Total). Shared by the QC form and the engagement fields.
 *
 *   rows         [{ key, title, subtitle?, control }]
 *   footer       node, rendered as the last row
 *   controlClass width of the input column (amounts by default)
 */
const SplitList = ({ rows, footer = null, controlClass = splitListAmount, className = '' }) => (
  <div className={`${splitList} ${className}`}>
    {rows.map((r) => (
      <div key={r.key} className={splitListRow}>
        <div className="flex-1 min-w-0">
          <div className={splitListTitle}>{r.title}</div>
          {r.subtitle ? <div className={splitListSubtitle}>{r.subtitle}</div> : null}
        </div>
        <div className={controlClass}>{r.control}</div>
      </div>
    ))}
    {footer && <div className={splitListFooter}>{footer}</div>}
  </div>
);

export default SplitList;
